<template>
  <SlotPanel class="animate-pulse">
    <div class="w-full h-10 bg-link-primary/50 rounded" />
    <div class="flex justify-between mt-4">
      <div class="w-1/2 mr-2 h-8 bg-tertiary rounded" />
      <div class="w-1/2 ml-2 h-8 bg-tertiary rounded" />
    </div>
    <div class="mt-6 relative">
      <div class="w-3/4 mr-2 h-8 bg-tertiary rounded" />
      <div
        class="absolute right-0 top-1/2 translate-x-3/4 -translate-y-1/2 -mt-1 bg-surface-primary border-2 border-linear-subtle w-16 h-6 rounded shadow-podHover"
      />
    </div>
    <div class="flex justify-between mt-4">
      <div class="w-1/2 mr-2 h-4 bg-tertiary rounded" />
      <div class="w-1/2 mr-2 h-4 bg-tertiary rounded" />
    </div>
  </SlotPanel>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import SlotPanel from '@/common/components/organisms/SlotPanel.vue'

export default defineComponent({
  name: 'ReservationDetailSkeleton',
  components: { SlotPanel },
})
</script>
